import { render, staticRenderFns } from "./QuotationStepDeal.vue?vue&type=template&id=6ed70e59&scoped=true"
import script from "./QuotationStepDeal.vue?vue&type=script&lang=js"
export * from "./QuotationStepDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed70e59",
  null
  
)

export default component.exports